import { useEffect, useState } from "react";
import { toast } from "sonner";
import { QRCodeSVG } from "qrcode.react";
import { Copy, Smartphone, Keyboard } from "lucide-react";
import { api, PUBLIC_ORIGIN } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

export const useClipKey = (onClip, enabled = true) => {
  useEffect(() => {
    if (!enabled) return;
    const h = (e) => {
      if (e.key.toLowerCase() !== "c" || e.ctrlKey || e.metaKey || e.altKey || e.repeat) return;
      if (e.target.closest?.("input, textarea, select, [contenteditable=true], [role=dialog]")) return;
      e.preventDefault();
      onClip();
    };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [onClip, enabled]);
};

export const QuickClipAccess = ({ panelUrl }) => {
  const { t } = useI18n();
  const [url, setUrl] = useState(panelUrl || "");
  useEffect(() => {
    if (panelUrl) { setUrl(panelUrl); return; }
    api.get("/integrations").then((r) => r.data.api_key && setUrl(`${PUBLIC_ORIGIN}/panel/${r.data.api_key}`)).catch(() => {});
  }, [panelUrl]);
  if (!url) return null;
  const copy = async () => { await navigator.clipboard.writeText(url); toast.success(t("qa.copied")); };
  return (
    <div className="mt-4 rounded-xl border border-[#ff2d55]/25 bg-[#ff2d55]/[0.05] p-4 flex flex-col sm:flex-row gap-4 items-center" data-testid="quick-clip-access">
      <div className="bg-white p-2 rounded-lg shrink-0" data-testid="quick-clip-qr"><QRCodeSVG value={url} size={112} /></div>
      <div className="min-w-0 flex-1 w-full space-y-2">
        <div className="text-sm font-semibold text-white flex items-center gap-2"><Smartphone className="w-4 h-4 text-[#ff7a00]" />{t("qa.title")}</div>
        <p className="text-[11px] text-slate-400">{t("qa.desc")}</p>
        <div className="flex gap-2">
          <input readOnly value={url} data-testid="quick-clip-url" className="flex-1 min-w-0 rounded-lg bg-[#070912] border border-white/10 px-3 py-2 text-xs font-mono text-slate-300" />
          <button onClick={copy} data-testid="quick-clip-copy-btn" className="cx-ghost rounded-lg px-3 py-2 text-xs flex items-center gap-1.5"><Copy className="w-3.5 h-3.5" />{t("qa.copy")}</button>
        </div>
        <div className="text-[11px] text-slate-400 flex items-center gap-1.5" data-testid="quick-clip-shortcut-hint"><Keyboard className="w-3.5 h-3.5" />{t("qa.key")}</div>
      </div>
    </div>
  );
};
